<template>
  <div class="bonusDialog z-top">
    <div
      v-if="closeCounterNumber || closeCounterNumber === 0"
      class="bonusDialog_close">
      <div
        v-if="count > 0"
        class="bonusDialog_close_count">{{ count }}</div>
      <div
        v-else
        class="bonusDialog_close_cross"
        @click="$emit('close-dialog')"></div>
    </div>
    <img
      src="../../../assets/images/xbb/coin_title.png"
      class="bonusDialog_icon"/>
    <div class="bonusDialog_title">
      <slot name="title"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'BonusDialog',
  props: {
    closeCounterNumber: {
      type: Number,
      validator (v) {
        return /^\d+$/.test(v)
      }
    }
  },
  data () {
    return {
      count: this.closeCounterNumber,
      intervalID: null
    }
  },
  mounted () {
    this.startCounter()
  },
  beforeDestroy () {
    this.endCounter()
  },
  methods: {
    startCounter () {
      if (this.closeCounterNumber) {
        this.intervalID = window.setInterval(this.counterHandler, 1000)
      }
    },
    endCounter () {
      if (this.intervalID) {
        window.clearInterval(this.intervalID)
        this.intervalID = null
      }
    },
    counterHandler () {
      const count = this.count - 1
      if (count < 0) {
        this.endCounter()
      } else {
        this.count = count
      }
    }
  }
}
</script>

<style scoped>
.bonusDialog {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  max-width: 560px;
  min-height: 150px;
  padding: 28px 12px 12px 12px;
  margin: auto;
  overflow: visible;
  text-align: center;
  background-color: #fff;
  border: 6px solid #ecc374;
  border-radius: 11px;
}

.bonusDialog_icon {
  position: absolute;
  top: 0;
  left: 50%;
  width: 140px;
  height: 100px;
  margin: -75px 0 0 -70px;
}

.bonusDialog_title {
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
  color: #262626;
}

.z-top {
  z-index: 7000;
}

.bonusDialog_close {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background-color: #faf5f1;
  border: 5px solid #bd9e7f;
  border-radius: 50%;
  transform: translate(50%, -50%);
}

.bonusDialog_close_count {
  font-size: 32px;
  font-weight: 900;
  color: #bd9e7f;
}

.bonusDialog_close_cross {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.bonusDialog_close_cross::before,
.bonusDialog_close_cross::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 5px;
  content: "";
  background-color: #bd9e7f;
}

.bonusDialog_close_cross::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.bonusDialog_close_cross::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

</style>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusDialog.vue